import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPostRequest,
  apiPutRequest,
  apiGetByIdRequest,
  apiGetRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { checkAllFieldHasValue } from "src/utils/utils";
import { kmMessages } from "src/constant/Messages";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
  editroot: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`user-tabpanel-${index}`}
      aria-labelledby={`user-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

const headCells = [
  {
    id: "lp",
    numeric: false,
    lp: true,
    disablePadding: false,
    sortable: true,
    main: false,
    label: "L.p.",
  },
  {
    id: "fieldName",
    numeric: false,
    disablePadding: false,
    fieldName: "fieldName",
    sortable: true,
    main: true,
    label: "Nazwa pola",
    dataType: 2,
    dataLabels: {
      username: "Login",
      fname: "Imię",
      lname: "Nazwisko",
      email: "E-mail",
      profiles: "Profile",
      institution: "Instytucja",
      function: "Funkcja",
      workinggroups: "Grupy robocze",
      additionalinfo: "Informacje dodatkowe",
      activeuntil: "Data aktywności",
      status: "Status",
      nolimitactive: "Aktywność konta - czas nieokreślony",
    },
  },
  {
    id: "valueBefore",
    numeric: false,
    disablePadding: false,
    fieldName: "valueBeforeChange",
    sortable: true,
    main: true,
    label: "Wartość przed zmianą",
  },
  {
    id: "valueAfter",
    numeric: false,
    disablePadding: false,
    fieldName: "valueAfterChange",
    sortable: true,
    main: true,
    label: "Wartość po zmianie",
  },
  {
    id: "created",
    fieldName: "createdBy",
    fieldName2: "createdAt",
    kmUdField: true,
    numeric: false,
    disablePadding: false,
    sortable: true,
    searchable: true,
    label: "Kto i kiedy zmodyfikował",
  },
];

const User = ({
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();

  const [user, setUser] = useState(null);
  const [userChanges, setUserChanges] = useState([]);

  const [profiles, setProfiles] = useState(null);
  const [institutions, setInstitutions] = useState(null);
  const [workingGroups, setWorkingGroups] = useState(null);
  const [functions, setFunctions] = useState(null);

  const editMode = rest.kmaction === "edit";
  const [areDictsLoaded, setDictsLoaded] = useState(false);

  const [activeDate, setActiveDate] = useState(null);
  const [tabNo, setTabNo] = useState(0);

  let pageTitle =
    rest.kmaction === "new" ? "Nowy użytkownik" : "Edycja użytkownika";

  let dictsLoadStatus = {
    profiles: false,
    institutions: false,
    workingGroups: false,
    functions: false,
  };

  useEffect(() => {
    enableGlobalLoader();
    apiGetRequest(apiEndpoints.getProfiles.path, true)
      .then((data) => {
        disableGlobalLoader();
        setProfiles(data);
        dictsLoadStatus = { ...dictsLoadStatus, profiles: true };
        setDictsLoaded(checkAllFieldHasValue(dictsLoadStatus, true));
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        } else {
          navigate("/uzytkownicy");
        }
      });
    apiGetRequest(apiEndpoints.getInstitutions.path, true)
      .then((data) => {
        disableGlobalLoader();
        setInstitutions(data);
        dictsLoadStatus = { ...dictsLoadStatus, institutions: true };
        setDictsLoaded(checkAllFieldHasValue(dictsLoadStatus, true));
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        } else {
          navigate("/uzytkownicy");
        }
      });
    apiGetRequest(apiEndpoints.getWorkingGroups.path, true)
      .then((data) => {
        disableGlobalLoader();
        setWorkingGroups(data);
        dictsLoadStatus = { ...dictsLoadStatus, workingGroups: true };
        setDictsLoaded(checkAllFieldHasValue(dictsLoadStatus, true));
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        } else {
          navigate("/uzytkownicy");
        }
      });
    apiGetRequest(apiEndpoints.getFunctions.path, true)
      .then((data) => {
        disableGlobalLoader();
        setFunctions(data);
        dictsLoadStatus = { ...dictsLoadStatus, functions: true };
        setDictsLoaded(checkAllFieldHasValue(dictsLoadStatus, true));
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        } else {
          navigate("/uzytkownicy");
        }
      });
    if (editMode) {
      enableGlobalLoader();
      apiGetByIdRequest(apiEndpoints.getUserDetails.path, entryId, true)
        .then((data) => {
          disableGlobalLoader();
          setUser(data);
        })
        .catch((error) => {
          disableGlobalLoader();
        });
      apiGetByIdRequest(apiEndpoints.getUserChangesDetails.path, entryId, true)
        .then((data) => {
          disableGlobalLoader();
          setUserChanges(data);
        })
        .catch((error) => {
          disableGlobalLoader();
        });
    }
    return () => {};
  }, []);

  const onSubmit = (data) => {

    if (data.status === "active" && !activeDate && !data.activeinf) {
      displaySnackbar({
        isOpen: true,
        severity: "error",
        autoHideDuration: 8000,
        message: kmMessages.error.form_validation.activity_not_defined,
      });
    } else {
      enableGlobalLoader();

      if (editMode) {
        apiPutRequest(
          apiEndpoints.updateUser.path,
          {
            id: entryId,
            username: data.username,
            firstName: data.fname,
            lastName: data.lname,
            email: data.email,
            profileIds: data.profiles.map((profile) => profile.id),
            institutionId: data.institution.id,
            functionId: data.funct.id,
            workGroupsIds: data.workinggroups.map(
              (workinggroup) => workinggroup.id
            ),
            additionalInfo: data.addinfo ? data.addinfo : null,
            active: data.status === "active" ? true : false,
            activationDate: activeDate ? activeDate.format("YYYY-MM-DD") : null,
            activeInfinity: data.activeinf,
          },
          true
        )
          .then((data) => {
            disableGlobalLoader();
            navigate("/uzytkownicy");
          })
          .catch((error) => {
            disableGlobalLoader();
            submitErrorHandle(error);
          });
      } else {
        apiPostRequest(
          apiEndpoints.addUser.path,
          {
            username: data.username,
            firstName: data.fname,
            lastName: data.lname,
            email: data.email,
            profileIds: data.profiles.map((profile) => profile.id),
            institutionId: data.institution.id,
            functionId: data.funct.id,
            workGroupsIds: data.workinggroups.map(
              (workinggroup) => workinggroup.id
            ),
            additionalInfo: data.addinfo ? data.addinfo : null,
            active: data.status === "active" ? true : false,
            activationDate: activeDate ? activeDate.format("YYYY-MM-DD") : null,
            activeInfinity: data.activeinf,
          },
          true
        )
          .then((data) => {
            disableGlobalLoader();
            navigate("/uzytkownicy");
          })
          .catch((error) => {
            disableGlobalLoader();
            submitErrorHandle(error);
          });
      }
    }
  };

  const submitErrorHandle = (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        setLogoutUser();
      } else if (error.response.status === 400 && error.response.data) {
        if (error.response.data.code === "USER_WITH_EMAIL_EXISTS") {
          displaySnackbar({
            isOpen: true,
            severity: "error",
            autoHideDuration: 8000,
            message: kmMessages.error.form_validation.email_exists,
          });
        } else if (error.response.data.code === "USER_WITH_USERNAME_EXISTS") {
          displaySnackbar({
            isOpen: true,
            severity: "error",
            autoHideDuration: 8000,
            message: kmMessages.error.form_validation.username_exists,
          });
        } else if (error.response.data.code === "USER_ACTIVATION_DATE_IN_THE_PAST") {
          displaySnackbar({
            isOpen: true,
            severity: "error",
            autoHideDuration: 8000,
            message: kmMessages.error.form_validation.activation_inpast,
          });
        } else if (
          error.response.data.code === "USER_WITH_FUNCTION_ROLE_EXISTS"
        ) {
          displaySnackbar({
            isOpen: true,
            severity: "error",
            autoHideDuration: 8000,
            message: kmMessages.error.users.user_with_function_exists,
          });
        }
      }
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabNo(newValue);
  };

  function a11yProps(index) {
    return {
      id: `user-tab-${index}`,
      "aria-controls": `user-tabpanel-${index}`,
    };
  }

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          {editMode ? (
            <div>
              <AppBar position="static">
                <Tabs
                  value={tabNo}
                  onChange={handleTabChange}
                  aria-label="Użytkownik"
                >
                  <Tab label="Dane użytkownika" {...a11yProps(0)} />
                  <Tab label="Historia zmian" {...a11yProps(1)} />
                </Tabs>
              </AppBar>
              <TabPanel value={tabNo} index={0} className={classes.editroot}>
                <Form
                  onSubmit={onSubmit}
                  profiles={profiles}
                  institutions={institutions}
                  workingGroups={workingGroups}
                  functions={functions}
                  user={user}
                  editMode={editMode}
                  areDictsLoaded={areDictsLoaded}
                  activeDate={activeDate}
                  setActiveDate={setActiveDate}
                />
              </TabPanel>
              <TabPanel value={tabNo} index={1} className={classes.editroot}>
                <KmFilteredTable
                  searchable={false}
                  markable={false}
                  headCells={headCells}
                  rows={userChanges}
                />
              </TabPanel>
            </div>
          ) : (
            <Form
              onSubmit={onSubmit}
              profiles={profiles}
              institutions={institutions}
              workingGroups={workingGroups}
              functions={functions}
              user={user}
              editMode={editMode}
              areDictsLoaded={areDictsLoaded}
              activeDate={activeDate}
              setActiveDate={setActiveDate}
            />
          )}
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
});

export default connect(null, mapDispatchToProps)(User);
